/** @jsx jsx */
import React from 'react'
import { css, jsx } from '@emotion/react'
import Layout from '../components/Layout'
import ThemeWrapper from '../components/Theme'
import { Column, ColumnWrap, ColumnWrapper, Title, Text, Button, Image, ContactForm } from '@swp/components'
import SiteHeader from '../components/SiteHeader'

export default function Page(props) {
  return (
    <ThemeWrapper>
      <Layout >
        <SiteHeader />

        <Column className="css-ttyirh --full" name={"uvod"} fullscreen={true} css={css`
        
    background-image: linear-gradient(var(--overlay-color), var(--overlay-color)), url(https://cdn.swbpg.com/t/i/template/83/img-2_s=350x_.jpg);
    @media (min-width: 351px) {
      background-image: linear-gradient(var(--overlay-color), var(--overlay-color)), url(https://cdn.swbpg.com/t/i/template/83/img-2_s=660x_.jpg);
    }
    @media (min-width: 661px) {
      background-image: linear-gradient(var(--overlay-color), var(--overlay-color)), url(https://cdn.swbpg.com/t/i/template/83/img-2_s=860x_.jpg);
    }
    @media (min-width: 861px) {
      background-image: linear-gradient(var(--overlay-color), var(--overlay-color)), url(https://cdn.swbpg.com/t/i/template/83/img-2_s=1400x_.jpg);
    }
    @media (min-width: 1401px) {
      background-image: linear-gradient(var(--overlay-color), var(--overlay-color)), url(https://cdn.swbpg.com/t/i/template/83/img-2_s=2000x_.jpg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (max-width: 350px) {
      background-image: linear-gradient(var(--overlay-color), var(--overlay-color)), url(https://cdn.swbpg.com/t/i/template/83/img-2_s=660x_.jpg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (min-width: 351px) {
      background-image: linear-gradient(var(--overlay-color), var(--overlay-color)), url(https://cdn.swbpg.com/t/i/template/83/img-2_s=1400x_.jpg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (min-width: 861px) {
      background-image: linear-gradient(var(--overlay-color), var(--overlay-color)), url(https://cdn.swbpg.com/t/i/template/83/img-2_s=3000x_.jpg);
    }
  
      `}>
          
          <ColumnWrap className="column__flex el--1 pb--40 flex--bottom" columns={"1"} fullscreen={false}>
            
            <ColumnWrapper >
              
              <Title className="title-box fs--62 w--400 lh--1" style={{"maxWidth":640}} content={"<span style='color: white'>Stavební a elektrické práce pro byty</span>"}>
              </Title>

              <Text className="text-box fs--20 ls--02 lh--16 mt--20" style={{"maxWidth":640}} content={"<span style='color: white'>Klikněte a začněte psát text, tento prostor je určený pro text. Některé prvky obsahují specifické funkce.</span>"}>
              </Text>

              <Button className="btn-box btn-box--hvr3 btn-box--shape3 btn-box--shadow5" href={"#[[T75SecName7]]"} content={"Kontaktovat"}>
              </Button>

            </ColumnWrapper>

          </ColumnWrap>

        </Column>


        <Column className="pb--60 pt--60" name={"sluzby"}>
          
          <ColumnWrap className="column__flex --center el--3 pb--20 pt--20 flex--center" columns={"3"} fullscreen={false}>
            
            <ColumnWrapper style={{"maxWidth":300}}>
              
              <Image alt={"Obrázek editujete kliknutím"} src={"https://cdn.swbpg.com/o/g/Ikonky/obecne/88e67c255f7d45fbadefead760a44b9f.svg"} svg={false} ratio={"1:1"} sizes={"100vw"} style={{"maxWidth":100}} srcSet={""} content={null}>
              </Image>

              <Title className="title-box" content={"Rekonstrukce"}>
              </Title>

              <Text className="text-box" content={"Začněte psát text, tento prostor je určený pro váš libovolný text."}>
              </Text>

            </ColumnWrapper>

            <ColumnWrapper style={{"maxWidth":300}}>
              
              <Image alt={"Obrázek editujete kliknutím"} src={"https://cdn.swbpg.com/o/g/Ikonky/kvetinarstvi/1c76659180bd4159b6d9b4804db35767.svg"} svg={false} ratio={"1:1"} sizes={"100vw"} style={{"maxWidth":100}} srcSet={""} content={null}>
              </Image>

              <Title className="title-box" content={"Exteriérové služby"}>
              </Title>

              <Text className="text-box" content={"Začněte psát text, tento prostor je určený pro váš libovolný text."}>
              </Text>

            </ColumnWrapper>

            <ColumnWrapper className="--center" style={{"maxWidth":300}}>
              
              <Image alt={"Obrázek editujete kliknutím"} src={"https://cdn.swbpg.com/o/g/Ikonky/Kontakt/1bf57d65067e4fcd82d8e6c77685617b.svg"} svg={false} ratio={"1:1"} sizes={"100vw"} style={{"maxWidth":100}} srcSet={""} content={null}>
              </Image>

              <Title className="title-box w--300 ls--002" content={"Malování budov"}>
              </Title>

              <Text className="text-box" style={{"maxWidth":""}} content={"Začněte psát text, tento prostor je určený pro váš libovolný text."}>
              </Text>

            </ColumnWrapper>

          </ColumnWrap>

        </Column>


        <Column name={"fotogalerie"} layout={"l12"}>
          
          <ColumnWrap className="column__flex --center el--4 --full" columns={"4"} fullscreen={true}>
            
            <ColumnWrapper >
              
              <Image alt={"Obrázek editujete kliknutím"} src={"https://cdn.swbpg.com/t/i/template/83/img-1_s=350x_.jpg"} svg={false} ratio={"1:1"} sizes={"(min-width: 40em) 28vw, 100vw"} srcSet={"https://cdn.swbpg.com/t/i/template/83/img-1_s=350x_.jpg 350w, https://cdn.swbpg.com/t/i/template/83/img-1_s=660x_.jpg 660w, https://cdn.swbpg.com/t/i/template/83/img-1_s=860x_.jpg 860w, https://cdn.swbpg.com/t/i/template/83/img-1_s=1400x_.jpg 1400w, https://cdn.swbpg.com/t/i/template/83/img-1_s=2000x_.jpg 2000w"} content={null}>
              </Image>

            </ColumnWrapper>

            <ColumnWrapper >
              
              <Image alt={"Obrázek editujete kliknutím"} src={"https://cdn.swbpg.com/t/i/template/83/img-2_s=350x_.jpg"} svg={false} ratio={"1:1"} sizes={"(min-width: 40em) 28vw, 100vw"} srcSet={"https://cdn.swbpg.com/t/i/template/83/img-2_s=350x_.jpg 350w, https://cdn.swbpg.com/t/i/template/83/img-2_s=660x_.jpg 660w, https://cdn.swbpg.com/t/i/template/83/img-2_s=860x_.jpg 860w, https://cdn.swbpg.com/t/i/template/83/img-2_s=1400x_.jpg 1400w, https://cdn.swbpg.com/t/i/template/83/img-2_s=2000x_.jpg 2000w"} content={null}>
              </Image>

            </ColumnWrapper>

            <ColumnWrapper >
              
              <Image alt={"Obrázek editujete kliknutím"} src={"https://cdn.swbpg.com/t/i/template/83/img-3_s=350x_.jpg"} svg={false} ratio={"1:1"} sizes={"(min-width: 40em) 28vw, 100vw"} srcSet={"https://cdn.swbpg.com/t/i/template/83/img-3_s=350x_.jpg 350w, https://cdn.swbpg.com/t/i/template/83/img-3_s=660x_.jpg 660w, https://cdn.swbpg.com/t/i/template/83/img-3_s=860x_.jpg 860w, https://cdn.swbpg.com/t/i/template/83/img-3_s=1400x_.jpg 1400w, https://cdn.swbpg.com/t/i/template/83/img-3_s=2000x_.jpg 2000w"} content={null}>
              </Image>

            </ColumnWrapper>

            <ColumnWrapper >
              
              <Image alt={"Obrázek editujete kliknutím"} src={"https://cdn.swbpg.com/t/i/template/83/img-1_s=860x_.jpg"} svg={false} ratio={"1:1"} sizes={"(min-width: 40em) 28vw, 100vw"} srcSet={"https://cdn.swbpg.com/t/i/template/83/img-1_s=350x_.jpg 350w, https://cdn.swbpg.com/t/i/template/83/img-1_s=660x_.jpg 660w, https://cdn.swbpg.com/t/i/template/83/img-1_s=860x_.jpg 860w, https://cdn.swbpg.com/t/i/template/83/img-1_s=1400x_.jpg 1400w, https://cdn.swbpg.com/t/i/template/83/img-1_s=2000x_.jpg 2000w"} content={null}>
              </Image>

            </ColumnWrapper>

          </ColumnWrap>

        </Column>


        <Column name={"reference"} style={{"paddingTop":null,"backgroundColor":"var(--color-supplementary)"}}>
          
          <ColumnWrap className="column__flex --center el--1 pb--60 pt--60" columns={"1"} fullscreen={false}>
            
            <ColumnWrapper >
              
              <Title className="title-box fs--48 w--400" content={"<span style='color: var(--color-dominant)'>Reference</span>"}>
              </Title>

              <Text className="text-box fs--20 lh--16" style={{"maxWidth":510}} content={"Klikněte a začněte psát text, tento prostor je určený pro text. Některé prvky obsahují specifické funkce."}>
              </Text>

              <Button className="btn-box btn-box--hvr3 btn-box--shape3 btn-box--shadow5 fs--20" href={"#[[T75SecName7]]"} content={"Kontaktovat"}>
              </Button>

            </ColumnWrapper>

          </ColumnWrap>

        </Column>


        <Column className="pb--60 pt--60" name={"reference-2"} style={{"backgroundColor":"var(--color-blend-95)"}}>
          
          <ColumnWrap className="column__flex --center el--3 mt--0 flex--top" columns={"3"} fullscreen={false}>
            
            <ColumnWrapper className="mb--08 pb--20 pl--10 pr--10 pt--10" style={{"maxWidth":600,"backgroundColor":"var(--color-dominant)"}}>
              
              <Image alt={"Obrázek editujete kliknutím"} src={"https://cdn.swbpg.com/t/i/template/83/img-1_s=860x_.jpg"} svg={false} ratio={"3:2"} sizes={"(min-width: 40em) 28vw, 100vw"} srcSet={"https://cdn.swbpg.com/t/i/template/83/img-1_s=350x_.jpg 350w, https://cdn.swbpg.com/t/i/template/83/img-1_s=660x_.jpg 660w, https://cdn.swbpg.com/t/i/template/83/img-1_s=860x_.jpg 860w, https://cdn.swbpg.com/t/i/template/83/img-1_s=1400x_.jpg 1400w, https://cdn.swbpg.com/t/i/template/83/img-1_s=2000x_.jpg 2000w"} content={null}>
              </Image>

              <Title className="title-box mt--06" content={"Rekonstrukce domu kultury Ostrava"}>
              </Title>

              <Text className="text-box" content={"Začněte psát text, tento prostor je určený pro váš libovolný text."}>
              </Text>

            </ColumnWrapper>

            <ColumnWrapper className="mb--08 pb--20 pl--10 pr--10 pt--10" style={{"maxWidth":600,"backgroundColor":"var(--color-dominant)"}}>
              
              <Image alt={"Obrázek editujete kliknutím"} src={"https://cdn.swbpg.com/t/i/template/83/img-2_s=860x_.jpg"} svg={false} ratio={"3:2"} sizes={"(min-width: 40em) 28vw, 100vw"} srcSet={"https://cdn.swbpg.com/t/i/template/83/img-2_s=350x_.jpg 350w, https://cdn.swbpg.com/t/i/template/83/img-2_s=660x_.jpg 660w, https://cdn.swbpg.com/t/i/template/83/img-2_s=860x_.jpg 860w, https://cdn.swbpg.com/t/i/template/83/img-2_s=1400x_.jpg 1400w, https://cdn.swbpg.com/t/i/template/83/img-2_s=2000x_.jpg 2000w"} content={null}>
              </Image>

              <Title className="title-box mt--06" content={"Rekonstrukce domu kultury Ostrava"}>
              </Title>

              <Text className="text-box" content={"Začněte psát text, tento prostor je určený pro váš libovolný text."}>
              </Text>

            </ColumnWrapper>

            <ColumnWrapper className="mb--08 pb--20 pl--10 pr--10 pt--10" style={{"maxWidth":600,"backgroundColor":"var(--color-dominant)"}}>
              
              <Image alt={"Obrázek editujete kliknutím"} src={"https://cdn.swbpg.com/t/i/template/83/img-3_s=860x_.jpg"} svg={false} ratio={"3:2"} sizes={"(min-width: 40em) 28vw, 100vw"} srcSet={"https://cdn.swbpg.com/t/i/template/83/img-3_s=350x_.jpg 350w, https://cdn.swbpg.com/t/i/template/83/img-3_s=660x_.jpg 660w, https://cdn.swbpg.com/t/i/template/83/img-3_s=860x_.jpg 860w, https://cdn.swbpg.com/t/i/template/83/img-3_s=1400x_.jpg 1400w, https://cdn.swbpg.com/t/i/template/83/img-3_s=2000x_.jpg 2000w"} content={null}>
              </Image>

              <Title className="title-box mt--06" content={"Rekonstrukce domu kultury Ostrava"}>
              </Title>

              <Text className="text-box" content={"Začněte psát text, tento prostor je určený pro váš libovolný text."}>
              </Text>

            </ColumnWrapper>

            <ColumnWrapper className="mb--08 pb--20 pl--10 pr--10 pt--10" style={{"maxWidth":600,"backgroundColor":"var(--color-dominant)"}}>
              
              <Image alt={"Obrázek editujete kliknutím"} src={"https://cdn.swbpg.com/t/i/template/83/img-1_s=860x_.jpg"} svg={false} ratio={"3:2"} sizes={"(min-width: 40em) 28vw, 100vw"} srcSet={"https://cdn.swbpg.com/t/i/template/83/img-1_s=350x_.jpg 350w, https://cdn.swbpg.com/t/i/template/83/img-1_s=660x_.jpg 660w, https://cdn.swbpg.com/t/i/template/83/img-1_s=860x_.jpg 860w, https://cdn.swbpg.com/t/i/template/83/img-1_s=1400x_.jpg 1400w, https://cdn.swbpg.com/t/i/template/83/img-1_s=2000x_.jpg 2000w"} content={null}>
              </Image>

              <Title className="title-box mt--06" content={"Rekonstrukce domu kultury Ostrava"}>
              </Title>

              <Text className="text-box" content={"Začněte psát text, tento prostor je určený pro váš libovolný text."}>
              </Text>

            </ColumnWrapper>

            <ColumnWrapper className="mb--08 pb--20 pl--10 pr--10 pt--10" style={{"maxWidth":600,"backgroundColor":"var(--color-dominant)"}}>
              
              <Image alt={"Obrázek editujete kliknutím"} src={"https://cdn.swbpg.com/t/i/template/83/img-2_s=860x_.jpg"} svg={false} ratio={"3:2"} sizes={"(min-width: 40em) 28vw, 100vw"} srcSet={"https://cdn.swbpg.com/t/i/template/83/img-2_s=350x_.jpg 350w, https://cdn.swbpg.com/t/i/template/83/img-2_s=660x_.jpg 660w, https://cdn.swbpg.com/t/i/template/83/img-2_s=860x_.jpg 860w, https://cdn.swbpg.com/t/i/template/83/img-2_s=1400x_.jpg 1400w, https://cdn.swbpg.com/t/i/template/83/img-2_s=2000x_.jpg 2000w"} content={null}>
              </Image>

              <Title className="title-box mt--06" content={"Rekonstrukce domu kultury Ostrava"}>
              </Title>

              <Text className="text-box" content={"Začněte psát text, tento prostor je určený pro váš libovolný text."}>
              </Text>

            </ColumnWrapper>

            <ColumnWrapper className="mb--08 pb--20 pl--10 pr--10 pt--10" style={{"maxWidth":600,"backgroundColor":"var(--color-dominant)"}}>
              
              <Image alt={"Obrázek editujete kliknutím"} src={"https://cdn.swbpg.com/t/i/template/83/img-3_s=860x_.jpg"} svg={false} ratio={"3:2"} sizes={"(min-width: 40em) 28vw, 100vw"} srcSet={"https://cdn.swbpg.com/t/i/template/83/img-3_s=350x_.jpg 350w, https://cdn.swbpg.com/t/i/template/83/img-3_s=660x_.jpg 660w, https://cdn.swbpg.com/t/i/template/83/img-3_s=860x_.jpg 860w, https://cdn.swbpg.com/t/i/template/83/img-3_s=1400x_.jpg 1400w, https://cdn.swbpg.com/t/i/template/83/img-3_s=2000x_.jpg 2000w"} content={null}>
              </Image>

              <Title className="title-box mt--06" content={"Rekonstrukce domu kultury Ostrava"}>
              </Title>

              <Text className="text-box" content={"Začněte psát text, tento prostor je určený pro váš libovolný text."}>
              </Text>

            </ColumnWrapper>

          </ColumnWrap>

        </Column>


        <Column name={"kontakt"} style={{"backgroundColor":"var(--color-supplementary)"}}>
          
          <ColumnWrap className="column__flex el--2 pb--60 pt--60" columns={"2"} fullscreen={false}>
            
            <ColumnWrapper >
              
              <Title className="title-box fs--48" content={"<span style='color: var(--color-dominant)'>Stavební a elektrické práce pro byty</span>"}>
              </Title>

              <Text className="text-box fs--20 ls--0 lh--16" content={"Začněte psát text, tento prostor je určený pro váš libovolný text."}>
              </Text>

              <Button className="btn-box btn-box--hvr3 btn-box--shape3 btn-box--shadow5" href={"#[[T75SecName7]]"} content={"Kontaktovat"}>
              </Button>

            </ColumnWrapper>

            <ColumnWrapper >
              
              <Text className="text-box fs--20 lh--16" content={"Klikněte a začněte psát text, tento prostor je určený pro text. Některé prvky obsahují specifické funkce."}>
              </Text>

              <Text className="text-box fs--20 w--300 ls--0 lh--16" content={"Začněte psát text, tento prostor je určený pro váš libovolný text."}>
              </Text>

              <Text className="text-box fs--20 lh--16" content={"Začněte psát text, tento prostor je určený pro váš libovolný text."}>
              </Text>

            </ColumnWrapper>

          </ColumnWrap>

        </Column>


        <Column className="css-1yv4g4y bg--bottom pb--80 pt--80" name={"kontakt-2"} css={css`
        
    background-image: linear-gradient(var(--overlay-color), var(--overlay-color)), url(https://cdn.swbpg.com/t/i/template/83/fullscreen_s=350x_.jpg);
    @media (min-width: 351px) {
      background-image: linear-gradient(var(--overlay-color), var(--overlay-color)), url(https://cdn.swbpg.com/t/i/template/83/fullscreen_s=660x_.jpg);
    }
    @media (min-width: 661px) {
      background-image: linear-gradient(var(--overlay-color), var(--overlay-color)), url(https://cdn.swbpg.com/t/i/template/83/fullscreen_s=860x_.jpg);
    }
    @media (min-width: 861px) {
      background-image: linear-gradient(var(--overlay-color), var(--overlay-color)), url(https://cdn.swbpg.com/t/i/template/83/fullscreen_s=1400x_.jpg);
    }
    @media (min-width: 1401px) {
      background-image: linear-gradient(var(--overlay-color), var(--overlay-color)), url(https://cdn.swbpg.com/t/i/template/83/fullscreen_s=2000x_.jpg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (max-width: 350px) {
      background-image: linear-gradient(var(--overlay-color), var(--overlay-color)), url(https://cdn.swbpg.com/t/i/template/83/fullscreen_s=660x_.jpg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (min-width: 351px) {
      background-image: linear-gradient(var(--overlay-color), var(--overlay-color)), url(https://cdn.swbpg.com/t/i/template/83/fullscreen_s=1400x_.jpg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (min-width: 861px) {
      background-image: linear-gradient(var(--overlay-color), var(--overlay-color)), url(https://cdn.swbpg.com/t/i/template/83/fullscreen_s=3000x_.jpg);
    }
  
      `}>
          
          <ColumnWrap className="column__flex --center el--1 pb--25 pt--25" columns={"1"}>
            
            <ColumnWrapper >
              
              <Title className="title-box fs--48" content={"<span style='color: white'>Ozvěme se Vám</span>"}>
              </Title>

            </ColumnWrapper>

            <ColumnWrapper >
              
              <ContactForm className="--shape2 --shape2 --style3 fs--18" style={{"maxWidth":740}} action={"/contact"} fields={[{"name":"Celé jméno","type":"text","required":true,"placeholder":"Zadejte celé jméno"},{"name":"Telefonní číslo","type":"text","placeholder":"Telefon +420"},{"name":"Kontaktní e-mail","type":"email","placeholder":"Zadejte Váš e-mail"},{"name":"Kontaktovat","type":"submit"}]}>
              </ContactForm>

            </ColumnWrapper>

          </ColumnWrap>

        </Column>


        <Column name={"paticka"}>
          
          <ColumnWrap className="column__flex el--4 mb--60 mt--60" columns={"4"} fullscreen={false}>
            
            <ColumnWrapper >
              
              <Title className="title-box" content={"Stavební práce"} maxWidth={"240"}>
              </Title>

              <Text className="text-box fs--16 lh--16" content={"Začněte psát text, tento prostor je určený pro váš libovolný text."} maxWidth={"240"}>
              </Text>

            </ColumnWrapper>

            <ColumnWrapper >
              
              <Title className="title-box" content={"Kontaktovat"} maxWidth={"180"}>
              </Title>

              <Text className="text-box fs--16 lh--16" content={"Heršpacká 18/342<br> Brno 635 00<br>Česká republika"} maxWidth={"240"}>
              </Text>

            </ColumnWrapper>

            <ColumnWrapper >
              
              <Title className="title-box" content={"Navigace"} maxWidth={"240"}>
              </Title>

              <Text className="text-box fs--16 lh--16" content={"<a href='#[[T75SecName0]]'>Zpět nahoru</a>"} maxWidth={"240"}>
              </Text>

              <Text className="text-box fs--16 lh--16 mt--0" content={"<a href='#[[T75SecName2]]'>Služby</a>"} maxWidth={"240"}>
              </Text>

              <Text className="text-box fs--16 lh--16 mt--0" content={"<a href='#[[T75SecName5]]'>Reference</a>"} maxWidth={"240"}>
              </Text>

              <Text className="text-box fs--16 lh--16 mt--0" content={"<a href='#[[T75SecName6]]'>Informace</a>"} maxWidth={"240"}>
              </Text>

            </ColumnWrapper>

            <ColumnWrapper className="--right">
              
              <Text className="text-box fs--26 lh--14" content={"<span style=\"text-decoration-line: underline;\">facebook</span>"}>
              </Text>

              <Text className="text-box fs--26 lh--14 mt--0" content={"<a href=\"https://saywebpage.com\">Tvorba web stránek</a>"}>
              </Text>

            </ColumnWrapper>

          </ColumnWrap>

        </Column>

      </Layout>
    </ThemeWrapper>
  )
}